window.$ = window.jQuery = require('jquery');

import 'jquery-validation'
import 'jquery-validation/dist/additional-methods'

import { getCookie, setCookie, hideToast, showToast} from './helpers'

import * as Popper from "@popperjs/core"
import Toast from 'bootstrap/js/dist/toast'
import Tab from 'bootstrap/js/dist/tab'
// import Modal from 'bootstrap/js/dist/modal'
import Collapse from 'bootstrap/js/dist/collapse'
import Tooltip from 'bootstrap/js/dist/tooltip'


window.delay = function () {
    let timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
}();


const $body = $('body');
const _token = $('meta[name="csrf-token"]').attr('content');
const app = function ($) {

    //header
    const header = () => {

        const headerMenu = () => {

            const $header__menu_trigger = $('[data-trigger-menu]');
            const $header__menu = $('.header__menu_mobile');
            const $header__overlay = $('.header__overlay');
            const $header__menu_close = $('.header__menu_close');

            $header__menu_trigger.on('click', function () {
                if ($(this).hasClass('open')) {
                    $(this).removeClass('open');
                    $header__menu.removeClass('open');
                    $header__overlay.removeClass('open');
                    $body.removeClass('modal__open');
                } else {
                    // console.log('111')
                    $(this).addClass('open');
                    $header__menu.addClass('open');
                    $header__overlay.addClass('open');
                    $body.addClass('modal__open');
                }
            });

            $header__menu_close.on('click', function () {
                $header__menu_trigger.removeClass('open');
                $header__menu.removeClass('open');
                $header__overlay.removeClass('open');
                $body.removeClass('modal__open');
            });
        }

        const headerScroll = () => {

            const $header__bottom = $('.header__bottom');

            let window_w = $(window).width();

            let scrollPos = $(window).scrollTop();
            let scrollPosLast = $(window).scrollTop();

            if (window_w < 1200) {
                scrollPos > 88 ? $header__bottom.addClass('header__scroll') : $header__bottom.removeClass('header__scroll');
            } else {
                scrollPos > 53 ? $header__bottom.addClass('header__scroll') : $header__bottom.removeClass('header__scroll');
            }

            window.addEventListener('scroll', function (event) {
                scrollPos = $(window).scrollTop();

                if (scrollPos > scrollPosLast) {
                    // console.log('down')
                    scrollPos > 88 ? $header__bottom.addClass('header__scroll').removeClass('header__pin') : '';
                } else {
                    // console.log('up')
                    $header__bottom.addClass('header__pin')
                    scrollPos <= 1 ? $header__bottom.removeClass('header__scroll').removeClass('header__pin') : '';
                }

                scrollPosLast = scrollPos;

            });

        }

        const searchBlock = () => {

            const $search__trigger = $('[data-trigger-search]');
            const $header__search = $('.header__search_mobile');
            const $header__search_input = $header__search.find('input');
            const $header__overlay = $('.header__overlay');
            const $header__search_close = $('.header__search_close');

            $search__trigger.on('click', function () {
                if ($(this).hasClass('open')) {
                    $(this).removeClass('open');
                    $header__search_input.blur();
                    $header__search.removeClass('open');
                    $header__overlay.removeClass('open');
                    $body.removeClass('modal__open');
                } else {
                    $(this).addClass('search_open');
                    $header__search.addClass('open');
                    $header__search_input.focus();
                    $header__overlay.addClass('open');
                    $body.addClass('modal__open');
                }
            });

            $header__search_close.on('click', function () {
                $search__trigger.removeClass('open');
                $header__search.removeClass('open');
                $header__search_input.blur();
                $header__overlay.removeClass('open');
                $body.removeClass('modal__open');
            });
            $header__overlay.on('click', function () {
                $search__trigger.removeClass('open');
                $header__search.removeClass('open');
                $header__search_input.blur();
                $header__overlay.removeClass('open');
                $body.removeClass('modal__open');
            });
        }

        const catalogueMenu = () => {

            const $catalogue__trigger = $('[data-trigger-catalogue]');
            const $catalogue__trigger_mobile = $('[data-trigger-catalogue-mobile]');
            const $catalogue__trigger_item = $('[data-trigger-catalogue-item]');
            const $header__catalogue = $('.header__catalogue_desktop');
            const $header__catalogue_mobile = $('.header__catalogue_mobile');
            const $catalogue__list_item = $('.catalogue__list > li');
            const $header__overlay = $('.header__overlay');
            const $level__2 = $('.level__2');
            const $header__catalogue_close = $('.header__catalogue_close');

            const catalogTempListEl = $('.header__catalogue_list-block')
            const catalogTriggerItemEl = $('.catalogue__trigger_item')

            const closeCatalogueTempList = () => {
                catalogTempListEl.removeClass('open')
                catalogTempListEl.html()
                catalogTriggerItemEl.removeClass('active')
            }

            const desktopCatalogHandle = () => {
                const closeBtnEl = $('.header__catalogue_head button')
                const closeHeaderCatalogue = () => {
                    [$header__catalogue, $catalogue__trigger]
                        .forEach(item => item.removeClass('open'))
                    closeCatalogueTempList()
                    $header__overlay.removeClass('open');
                }

                $(window).scroll(function (e) {
                    closeHeaderCatalogue()
                });

                closeBtnEl.click(() => {
                    closeHeaderCatalogue()
                })

                let myTimeout;

                catalogTriggerItemEl.on('mouseover', function () {
                    const self = $(this)
                    myTimeout = setTimeout(myGreeting, 150);

                    function myGreeting() {
                        catalogTriggerItemEl.removeClass('active')
                        self.addClass('active')
                        if (!catalogTempListEl.hasClass('open')) {
                            catalogTempListEl.addClass('open')
                        }
                        const listEl = self.next()
                        if (listEl.length !== 0) {
                            catalogTempListEl.html(listEl[0].outerHTML)
                        } else {
                            closeCatalogueTempList()
                        }
                    }
                })
                catalogTriggerItemEl.on('mouseleave', function () {
                    clearTimeout(myTimeout);
                });

            }

            if (window.innerWidth > 1199) {
                desktopCatalogHandle()
            }

            const hideHeaderCatalogue = () => {
                $header__catalogue.removeClass('open')
                $catalogue__trigger.removeClass('open')
                $body.removeClass('modal__open');
                $header__overlay.removeClass('open');
            }

            $catalogue__trigger.on('click', function (e) {
                e.preventDefault();
                if ($(this).hasClass('open')) {
                    hideHeaderCatalogue()
                } else {
                    $(this).addClass('open');
                    $header__catalogue.addClass('open');
                    $header__overlay.addClass('open');
                }
            });

            $catalogue__trigger_mobile.on('click', function (e) {
                e.preventDefault();
                if ($(this).hasClass('open')) {
                    $(this).removeClass('open');
                    $header__catalogue_mobile.removeClass('open');
                } else {
                    $(this).addClass('open');
                    $header__catalogue_mobile.addClass('open');
                }
            });

            $header__catalogue_close.on('click', function () {
                $catalogue__trigger.removeClass('open');
                $catalogue__trigger_mobile.removeClass('open');
                $header__catalogue.removeClass('open');
                $header__catalogue_mobile.removeClass('open');
            });

            $catalogue__trigger_item.on('click', function (e) {
                let window_w = $(window).width();
                if (window_w < 1200) {
                    e.preventDefault()
                    if ($(this).hasClass('open')) {
                        $(this).removeClass('open');
                        $catalogue__list_item.removeClass('hidden__item');
                    } else {
                        $(this).addClass('open');
                        $catalogue__list_item.addClass('hidden__item');
                        $(this).parent().removeClass('hidden__item');
                    }
                }
            });

            $body.on('keydown', function (e) {
                if (e.keyCode === 27 || e.keyCode === 'esc') {
                    hideHeaderCatalogue()
                    closeCatalogueTempList()
                }
            });

            $header__overlay.on('click', function () {
                hideHeaderCatalogue()
                closeCatalogueTempList()
            });
        }

        const dropdownToggle = () => {

            const $dropdown__trigger = $('[data-trigger-dropdown]');
            const $dropdown__item = $dropdown__trigger.parent();

            $dropdown__trigger.on('click', function (e) {
                e.preventDefault();
                let $item = $(this).parent();
                if ($item.hasClass('dropdown__item_open')) {
                    $item.removeClass('dropdown__item_open')
                } else {
                    $dropdown__item.removeClass('dropdown__item_open');
                    $item.addClass('dropdown__item_open');
                }
            });

            $body.on('keydown', function (e) {
                if (e.keyCode === 27 || e.keyCode === 'esc') {
                    $dropdown__item.removeClass('dropdown__item_open')
                }
            });

            $body.on('click', function (e) {
                if ($(e.target).closest($dropdown__item).length)
                    return;
                $dropdown__item.removeClass('dropdown__item_open')
            });

        }

        const languageToggle = () => {

            const $lang__trigger = $('[data-trigger-lang]');
            const $header__lang = $lang__trigger.parent();

            $lang__trigger.on('click', function (e) {
                e.preventDefault();
                let $item = $(this).parent();
                if ($item.hasClass('header__lang_open')) {
                    $item.removeClass('header__lang_open')
                } else {
                    $header__lang.removeClass('header__lang_open');
                    $item.addClass('header__lang_open');
                }
            });

            $body.on('keydown', function (e) {
                if (e.keyCode === 27 || e.keyCode === 'esc') {
                    $header__lang.removeClass('header__lang_open');
                }
            });

            $body.on('click', function (e) {
                if ($(e.target).closest($header__lang).length)
                    return;
                $header__lang.removeClass('header__lang_open')
            });

        }

        headerMenu();
        languageToggle();
        dropdownToggle();
        searchBlock();
        catalogueMenu();
        headerScroll();
    }

    //common

    const addCookies = () => {

        let cookies = getCookie('cookies_accept');

        const cookiesElm = $('#cookies')
        const cookiesAccept = $('[data-cookies-accept]')

        cookiesAccept.on('click', function () {
            setCookie('cookies_accept', true, {expires: 2592000, path: '/'});
            hideToast(cookiesElm);
        })

        if (!cookies) {
            showToast(cookiesElm);
        }
    }

    const backToTop = () => {
        const $back_to_top = $('[data-back-to-top]');
        $back_to_top.on('click', function (e) {
            $("html, body").animate({scrollTop: 0}, 700);
            e.preventDefault();
        });
    };

    const tooltips = () => {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))
    };

    const favoritesAndCartActions = () => {

        const addToFavorites = () => {

            const $count_favorites = $('[data-count-favorites]');
            const $count_favorites_value = $count_favorites.find('.header__trigger_count');
            $(document).on('click', '.add_to_favorites', function (e) {
                e.preventDefault();

                let value = parseInt($count_favorites_value.html());
                const $this = $(this);
                const id = $this.attr('data-id');

                if ($this.hasClass('active')) {
                    $this.removeClass('active');
                    value--
                    if (value === 0) {
                        $count_favorites.removeClass('has-items')
                    }
                    $count_favorites_value.html(value)

                    //delete
                    delay(function () {
                        $.ajax({
                            url: '/delete-favorites',
                            method: "POST",
                            cache: false,
                            data: {id: id, _token: _token},
                            success: function (data) {
                                let counter = $(".product-favorites[data-id=" + id + "]").attr('data-productCount');
                                let c = counter - 1;

                                $(".product-favorites").attr('data-productCount', c)

                                if (counter == 1) {
                                    location.reload();
                                } else {
                                    $(".product-favorites[data-id=" + id + "]").remove();
                                }
                            }
                        });
                    }, 100);

                } else {
                    $this.addClass('active');
                    value++;
                    if (value > 0) {
                        $count_favorites.addClass('has-items')
                    }
                    $count_favorites_value.html(value)

                    //add
                    delay(function () {
                        $.ajax({
                            url: '/add-favorites',
                            method: "POST",
                            cache: false,
                            data: {id: id, _token: _token},
                            success: function (data) {
                                //
                            }
                        });
                    }, 100);
                }
            });
        }

        const deleteFavorites = () => {
            const delete_all_favorites = $('.delete_all_favorites');
            const $count_favorites = $('[data-count-favorites]');
            const $count_favorites_value = $count_favorites.find('.header__trigger_count');

            delete_all_favorites.on('click', function (e) {
                e.preventDefault();
                let value = parseInt($count_favorites_value.html());

                $count_favorites_value.html(value)

                //delete-all-favorites
                delay(function () {
                    $.ajax({
                        url: '/delete-all-favorites',
                        method: "POST",
                        cache: false,
                        data: {_token: _token},
                        success: function (data) {
                            if (data.success == true) {
                                $count_favorites_value.html(data.count)
                                if (data.count > 0) {
                                    $count_favorites.addClass('has-items')
                                }
                            }
                            location.reload();
                        }
                    });
                }, 100);
            });
        }

        const addToCart = () => {

            const $add_to_cart = $('[data-add-to-cart]');
            const toastElm = $('#added__to_cart');

            const $count_cart = $('[data-count-cart]');
            const $count_cart_value = $count_cart.find('.header__trigger_count');

            let counter = 0;
            let timer = null;

            function tictac() {
                counter++;
                if (counter > 2) {
                    toastElm.removeClass('show animate');
                    $add_to_cart.removeClass('active');
                    clearInterval(timer);
                    counter = 0
                }
            }

            function reset() {
                clearInterval(timer);
                counter = 0;
                startInterval();
            }

            function startInterval() {
                timer = setInterval(function () {
                    tictac();
                }, 1000);
            }

            $(document).on('click', '[data-add-to-cart]', function (e) {
                e.preventDefault();

                let value = parseInt($count_cart_value.html());
                const $this = $(this);
                const id = $this.attr('data-id');
                let delivery = $('#delivery__region').val();

                let qty = '';

                if ($this.hasClass('add_to_cart_large')) {
                    if ($('#quantity-product-cart')) {
                        qty = $('#quantity-product-cart').val();
                    }
                } else {
                    if ($('#quantity-cart')) {
                        qty = $('#quantity-cart').val();
                    }
                }

                $count_cart_value.html(value)

                if (!$this.hasClass('active')) {
                    $this.addClass('active ');
                } else {
                    reset();
                }

                if (toastElm.hasClass('show')) {
                    toastElm.removeClass('animate');
                    setTimeout(function () {
                        toastElm.addClass('animate');
                    }, 50);
                    reset();
                } else {
                    startInterval();
                    toastElm.addClass('show animate');
                }

                //add
                delay(function () {
                    $.ajax({
                        url: '/add-cart',
                        method: "POST",
                        cache: false,
                        data: {id: id, qty: qty, delivery: delivery, _token: _token},
                        success: function (data) {
                            $count_cart_value.html(data.count)
                            if (data.count > 0) {
                                $count_cart.addClass('has-items')
                            }
                        }
                    });
                }, 100);

            });

        }

        addToFavorites();
        deleteFavorites();
        addToCart();
    }

    return {
        init() {
            header()
            favoritesAndCartActions()
            addCookies();
            backToTop();
            tooltips();
        }
    }
};

window.app = app;

jQuery(document).ready(function ($) {
    app($).init();
});
